import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Axios from 'axios'
import { TextField, FormGroup, Button, SnackbarContent, withStyles, Card, CardContent } from '@material-ui/core'

import md5 from '../lib/md5'
import { api, path } from '../lib'

const MainCard = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: '10px 0',
    backgroundColor: theme.palette.background.paper,
  },
  appbar: {
    maxWidth: '100%',
    width: '500px',
    margin: 'auto'
  },
  card: {
    width: '500px',
    maxWidth: '100%',
    maxHeight: 500,
    overflow: 'scroll',
  },
})

class FirmwareField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      file: null,

      vn: '',
      key: '',
      dm: 'FAST-1000',

      checkSum: '',
      md5: '',

      periodCharging: null,
      periodCheck: null,
      configVer: null,
    }
  }

  onFileChange = async e => {
    e.persist()
    const result = await md5(e.target.files[0])
    console.log(result)

    this.setState({
      file: e.target.files[0],
      md5: result.md5,
      key: result.filename,
    })
  }

  onChecksumChange = e => {
    this.setState({
      checkSum: e.target.value
    })
  }

  onPCGChange = e => {
    this.setState({
      periodCharging: e.target.value
    })
  }

  onPCKChange = e => {
    this.setState({
      periodCheck: e.target.value
    })
  }

  onCVChange = e => {
    this.setState({
      configVer: e.target.value
    })
  }

  onVNChange = e => {
    this.setState({
      vn: e.target.value
    })
  }

  onGetClick = async e => {
    const { key, dm, vn, checkSum, periodCharging, periodCheck, configVer } = this.state
    if (!key || !dm || !vn) return

    const result = await api.firmware.post(path.FIRMWARE_UPLOAD, {
      dm,
      vn,
      key,
      ts: Date.now(),
      tz: new Date().getTimezoneOffset() * -1,
    }, {
      headers: {
        Authorization: `Bearer ${this.props.user && this.props.user.token}`
        // Authorization: `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay14bmNhaEBrbmV4LWRldi5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsInN1YiI6ImZpcmViYXNlLWFkbWluc2RrLXhuY2FoQGtuZXgtZGV2LmlhbS5nc2VydmljZWFjY291bnQuY29tIiwidWlkIjoib1IzbVZZODZTQmdadUx2ZFVQUjVlRiIsImF1ZCI6Ii92MS90b2tlbi9hY2Nlc3MiLCJpYXQiOjE1MzQ5MDQ5NTMsImV4cCI6MTUzNDkyMjk1M30.Ibj64fvpzcSNoaotIVV6Kz3adBpWGU4i4tIA0tk5Q68E92Uv30csfgU4Fo0_e3gKklRZQI-XthSUII5c7fZrXZxWh-ACq98YEk8lJzkmLPPIwj5GCOsX2IwBfCgtcIDTRXuPn_WhjT-h1TYtxi_0hRW6WRMvAsNedEyE8tGcjeVOEUF1F9lwRYiw1W9cyEpK-hlbtGUD_D9Fk8du1gHhOIuoXgKkL7BC-hakQH_j3kW7yn-MXu_pQVoSukeYH0VG6NGDWsjT3IKjiOFvlA_Ai3QzD76z3FHPKOuR39PPAGaP8e5o8_tLb8zUePORZf_dxtlK7-9mYHBW35zAbC_whg`
      }
    })

    const { uploadUrl } = result.data

    const FD = new FormData()
    FD.append('file', this.state.file)

    const res = await Axios.put(uploadUrl, FD, {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        console.log(percentCompleted)
      }
    })

    const data = {
      dm,
      vn,
      key,
      checkSum,
      ts: Date.now(),
      tz: new Date().getTimezoneOffset() * -1,
    }

    if (periodCharging) data.periodCharging = periodCharging
    if (periodCheck) data.periodCheck = periodCheck
    if (configVer) data.configVer = configVer

    const resultConfig = await api.firmware.post(path.FIRMWARE_CONFIG, data, {
      headers: {
        Authorization: `Bearer ${this.props.user && this.props.user.token}`
      }
    })

    console.log('finish', resultConfig.data)
  }

  render() {
    const { classes } = this.props
    return (
      <div className="firmware">
        <MainCard className="login">
          <Card className={classes.card}>
            <CardContent>
              <FormGroup>
                <TextField
                  id="vn"
                  onChange={this.onVNChange}
                  label="Version Number"
                  margin="normal"
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  id="md5"
                  onChange={this.onChecksumChange}
                  label="Check Sum"
                  margin="normal"
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  id="configVer"
                  onChange={this.onCVChange}
                  label="Config Version (Optional)"
                  margin="normal"
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  id="periodCharging"
                  type="number"
                  onChange={this.onPCGChange}
                  label="Period Charging (Optional)"
                  margin="normal"
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  id="periodCheck"
                  type="number"
                  onChange={this.onPCKChange}
                  label="Period Check (Optional)"
                  margin="normal"
                />
              </FormGroup>
              <input type="file" onChange={this.onFileChange}/>
              <FormGroup>
                <Button
                  onClick={this.onGetClick}
                  variant="contained"
                  disabled={this.state.md5 !== this.state.checkSum || this.state.md5 === ''}
                  color="primary">
                  Submit
                </Button>
              </FormGroup>
            </CardContent>
          </Card>
        </MainCard>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

export default connect(mapStateToProps)(withStyles(styles)(FirmwareField))


// WEBPACK FOOTER //
// ./src/components/FirmwareField.jsx